enum Status {
  Saved = 0,
  Submitted = 21,
  Resubmitted = 22,
  Endorsed = 41,
  Rejected = 42
}
enum Reason {
  Service = 1,
  Annual = 2,
  Study = 3,
  Sick = 4,
  Compensation = 5,
  Post = 6,
  Others = 7
}
enum AttendType {
  Attendance = 1,
  Absent = 2
}
export const traingLogbookEnum = { Status, Reason, AttendType }
